{
  "$schema": "https://sifa.id/schemas/activity-tiers/v1.json",
  "version": "1.3.0",
  "updated": "2026-08-25",
  "tiers": {
    "creation": {
      "label": "Made",
      "description": "Substantive records the actor authored: posts, articles, repos, galleries, livestreams, RSVPs, CV entries. Surfaced on the public profile and in the network timeline.",
      "shownOnPublicProfile": true
    },
    "action": {
      "label": "Did",
      "description": "Engagement records (likes, reposts, follows, votes, stars, reactions). Visible to the actor on the 'What is public about me' page and on the originating app, but not surfaced on the Sifa public profile.",
      "shownOnPublicProfile": false
    },
    "filtered": {
      "label": null,
      "description": "Configuration, infrastructure, moderation, game state, ephemeral consumption signals (bookmarks, highlights), and other records Sifa does not display anywhere. The records remain public on the actor's PDS regardless.",
      "shownOnPublicProfile": false
    }
  },
  "lexicons": {
    "app.atmobb.discussion.reply": {
      "tier": "creation",
      "app": "atmobb",
      "notes": "Replies are authored text, consistent with app.bsky.feed.post covering replies."
    },
    "app.atmobb.discussion.thread": {
      "tier": "creation",
      "app": "atmobb"
    },
    "app.beaconbits.beacon": {
      "tier": "creation",
      "app": "beaconbits"
    },
    "app.bsky.actor.profile": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Profile metadata record."
    },
    "app.bsky.feed.generator": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Feed generator definition record, not personal activity."
    },
    "app.bsky.feed.like": {
      "tier": "action",
      "app": "bluesky"
    },
    "app.bsky.feed.post": {
      "tier": "creation",
      "app": "bluesky",
      "notes": "Ambiguous: many posts are casual, but the lexicon also carries long-form posts and threads. Treated as creation; empty quote-posts (no text + record embed) are filtered at the consumer layer, not here."
    },
    "app.bsky.feed.repost": {
      "tier": "action",
      "app": "bluesky"
    },
    "app.bsky.graph.block": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Moderation record."
    },
    "app.bsky.graph.follow": {
      "tier": "action",
      "app": "bluesky"
    },
    "app.bsky.graph.list": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "User-curated list metadata; not surfaced as profile activity."
    },
    "app.bsky.graph.listblock": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Moderation record."
    },
    "app.bsky.graph.listitem": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "List membership; rendered via the parent list, not as standalone activity."
    },
    "app.bsky.graph.mute": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Moderation record."
    },
    "app.bsky.graph.starterpack": {
      "tier": "filtered",
      "app": "bluesky"
    },
    "app.bsky.graph.verification": {
      "tier": "creation",
      "app": "bluesky",
      "notes": "Diverges from app.bsky.graph.follow (action) on purpose: verifying another account's handle is a deliberate trust statement the actor authors, not a tap. Sifa renders it with its own card."
    },
    "app.certified.actor.membership": {
      "tier": "creation",
      "app": "certified",
      "notes": "Joining a group is a commitment, same shape as a Colibri or Open Social membership."
    },
    "app.certified.badge.award": {
      "tier": "creation",
      "app": "certified",
      "notes": "An endorsement issued to another DID. A trust signal the actor contributes, like a Bluesky verification."
    },
    "app.certified.badge.response": {
      "tier": "creation",
      "app": "certified",
      "notes": "The recipient's acceptance of a badge someone else awarded them. An accepted badge is a credential the person holds; rejected ones are hidden by an ACTIVITY_VISIBILITY_RULES predicate."
    },
    "app.collectivesocial.feed.list": {
      "tier": "creation",
      "app": "collectivesocial",
      "notes": "Auto-created default Inbox lists are filtered at the consumer layer via isDefault=true predicate."
    },
    "app.mcp.server": {
      "tier": "creation",
      "app": "mcp"
    },
    "app.photosky.collection": {
      "tier": "creation",
      "app": "zeens",
      "notes": "A curated photo collection on Zeens (still the app.photosky namespace)."
    },
    "app.sidetrail.trail": {
      "tier": "creation",
      "app": "semble"
    },
    "app.sidetrail.walk": {
      "tier": "creation",
      "app": "semble"
    },
    "app.userinput.discussion": {
      "tier": "creation",
      "app": "userinput"
    },
    "app.userinput.reply": {
      "tier": "creation",
      "app": "userinput",
      "notes": "Replies are authored text, consistent with app.bsky.feed.post covering replies."
    },
    "at.locale.project": {
      "tier": "creation",
      "app": "locale",
      "notes": "A localization project the actor owns: git source, source and target locales."
    },
    "at.locale.translation": {
      "tier": "creation",
      "app": "locale",
      "notes": "One authored translated string for a message key in a target locale."
    },
    "at.margin.annotation": {
      "tier": "creation",
      "app": "margin",
      "notes": "An annotation on someone else's text is still authored writing."
    },
    "at.margin.bookmark": {
      "tier": "filtered",
      "notes": "Bookmark \u2014 consumption signal, not creation.",
      "app": "margin"
    },
    "at.margin.highlight": {
      "tier": "filtered",
      "notes": "Highlight \u2014 consumption signal, not creation.",
      "app": "margin"
    },
    "at.margin.note": {
      "tier": "creation",
      "app": "margin"
    },
    "at.marque.domain": {
      "tier": "creation",
      "app": "marque"
    },
    "at.youandme.connection": {
      "tier": "creation",
      "app": "youandme"
    },
    "blog.pckt.mini.post": {
      "tier": "creation",
      "app": "pckt",
      "notes": "A pckt microblog post. Long-form pckt posts are site.standard.document instead."
    },
    "blue.flashes.feed.post": {
      "tier": "creation",
      "app": "flashes"
    },
    "blue.linkat.board": {
      "tier": "filtered",
      "notes": "Link-in-bio board; consumption signal.",
      "app": "linkat"
    },
    "buzz.bookhive.book": {
      "tier": "creation",
      "app": "bookhive"
    },
    "com.minomobi.music.composition": {
      "tier": "creation",
      "app": "minomobi"
    },
    "com.shinolabs.pinksea.oekaki": {
      "tier": "creation",
      "app": "pinksea",
      "notes": "A drawing made in PinkSea's canvas, stored as an image blob with alt text and tags."
    },
    "com.voxport.podcast.series": {
      "tier": "creation",
      "app": "voxport"
    },
    "com.whtwnd.blog.entry": {
      "tier": "creation",
      "app": "whitewind"
    },
    "community.lexicon.badge.award": {
      "tier": "creation",
      "app": "badges",
      "notes": "The award record is authored by the giver, so it is their attestation about someone else."
    },
    "community.lexicon.bookmarks.bookmark": {
      "tier": "filtered",
      "notes": "Bookmark \u2014 consumption signal.",
      "app": "kipclip"
    },
    "community.lexicon.calendar.rsvp": {
      "tier": "creation",
      "app": "smokesignal",
      "notes": "Ambiguous: RSVPs are reactions to events, but they are public commitments and the only Smoke Signal record Sifa scans today. Classified as creation."
    },
    "community.nooki.comments": {
      "tier": "creation",
      "app": "nooki",
      "notes": "Comments are authored text."
    },
    "community.nooki.membership": {
      "tier": "creation",
      "app": "nooki",
      "notes": "Joining a community, classified like social.colibri.membership (creation)."
    },
    "community.opensocial.membership": {
      "tier": "creation",
      "app": "opensocial",
      "notes": "Joining a community, classified like social.colibri.membership (creation)."
    },
    "computer.aetheros.page": {
      "tier": "creation",
      "app": "aetheros"
    },
    "dev.atvouch.graph.vouch": {
      "tier": "creation",
      "app": "atvouch",
      "notes": "Vouching for someone. Authored attestation, same reasoning as fund.at.graph.endorse."
    },
    "dev.baileytownsend.guestbook.entry": {
      "tier": "creation",
      "app": "guestbook",
      "notes": "Signing someone else's guestbook is a short authored message."
    },
    "dev.keytrace.claim": {
      "tier": "creation",
      "app": "keytrace"
    },
    "dev.skyboard.board": {
      "tier": "filtered",
      "notes": "Skyboard task-board metadata.",
      "app": "skyboard"
    },
    "dev.skyboard.op": {
      "tier": "filtered",
      "notes": "Skyboard operation log.",
      "app": "skyboard"
    },
    "dev.skyboard.task": {
      "tier": "filtered",
      "notes": "Skyboard task record.",
      "app": "skyboard"
    },
    "events.smokesignal.profile": {
      "tier": "filtered",
      "app": "smokesignal",
      "notes": "Profile metadata record."
    },
    "exchange.recipe.recipe": {
      "tier": "creation",
      "app": "recipe"
    },
    "fm.plyr.comment": {
      "tier": "creation",
      "app": "plyr",
      "notes": "Comments are authored text."
    },
    "forum.barazo.community.member": {
      "tier": "creation",
      "app": "barazo"
    },
    "forum.barazo.flag": {
      "tier": "filtered",
      "app": "barazo",
      "notes": "Moderation flag."
    },
    "forum.barazo.post": {
      "tier": "creation",
      "app": "barazo"
    },
    "forum.barazo.reaction": {
      "tier": "action",
      "app": "barazo"
    },
    "forum.barazo.reply": {
      "tier": "action",
      "app": "barazo",
      "notes": "Short conversational reply \u2014 engagement signal."
    },
    "forum.barazo.reputation.event": {
      "tier": "creation",
      "app": "barazo"
    },
    "fund.at.graph.endorse": {
      "tier": "creation",
      "app": "atfund",
      "notes": "Endorsing someone. Authored attestation, not engagement."
    },
    "fyi.asq.answer": {
      "tier": "creation",
      "app": "asq"
    },
    "fyi.asq.question": {
      "tier": "creation",
      "app": "asq"
    },
    "fyi.atstore.listing.review": {
      "tier": "creation",
      "app": "atstore"
    },
    "fyi.unravel.frontpage.post": {
      "tier": "creation",
      "app": "frontpage"
    },
    "fyi.unravel.frontpage.vote": {
      "tier": "action",
      "app": "frontpage"
    },
    "id.sifa.authConnection": {
      "tier": "filtered",
      "app": "sifa",
      "notes": "OAuth scope record."
    },
    "id.sifa.authMeet": {
      "tier": "filtered",
      "app": "sifa",
      "notes": "OAuth scope record."
    },
    "id.sifa.authProfile": {
      "tier": "filtered",
      "app": "sifa",
      "notes": "OAuth scope record."
    },
    "id.sifa.authProfileAccess": {
      "tier": "filtered",
      "app": "sifa",
      "notes": "OAuth profile-access record."
    },
    "id.sifa.authProject": {
      "tier": "filtered",
      "app": "sifa",
      "notes": "OAuth scope record."
    },
    "id.sifa.confirmation": {
      "tier": "action",
      "app": "sifa",
      "notes": "Confirmation that a record naming the actor is accurate (co-speaker credit, project membership)."
    },
    "id.sifa.endorsement": {
      "tier": "creation",
      "app": "sifa",
      "notes": "Endorsement authored by the actor about another profile."
    },
    "id.sifa.endorsement.confirmation": {
      "tier": "action",
      "app": "sifa",
      "notes": "Confirmation/acceptance of an endorsement received."
    },
    "id.sifa.graph.connection": {
      "tier": "creation",
      "app": "sifa",
      "notes": "Mutual professional connection record."
    },
    "id.sifa.graph.follow": {
      "tier": "action",
      "app": "sifa"
    },
    "id.sifa.meeting": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.certification": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.course": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.education": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.externalAccount": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.honor": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.language": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.location": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.position": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.presentation": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.presentationDelivery": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.project": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.publication": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.self": {
      "tier": "creation",
      "app": "sifa",
      "notes": "Sifa professional profile root."
    },
    "id.sifa.profile.skill": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.profile.volunteering": {
      "tier": "creation",
      "app": "sifa"
    },
    "id.sifa.project.member": {
      "tier": "creation",
      "app": "sifa",
      "notes": "Deprecated, never implemented. Superseded by id.sifa.confirmation."
    },
    "id.sifa.project.membership": {
      "tier": "creation",
      "app": "sifa",
      "notes": "Deprecated, never implemented. Superseded by id.sifa.confirmation."
    },
    "id.sifa.project.self": {
      "tier": "creation",
      "app": "sifa"
    },
    "io.atcr.repo.page": {
      "tier": "creation",
      "app": "atcr"
    },
    "io.calabro.watsm.program": {
      "tier": "creation",
      "app": "watsm"
    },
    "io.kich.recipe.recipe": {
      "tier": "creation",
      "app": "kich"
    },
    "is.kevara.directory.speaker": {
      "tier": "creation",
      "app": "kevara"
    },
    "li.plonk.paste": {
      "tier": "creation",
      "app": "plonk"
    },
    "link.pastesphere.snippet": {
      "tier": "creation",
      "app": "pastesphere"
    },
    "net.alternativeproto.submission": {
      "tier": "creation",
      "app": "alternativeproto"
    },
    "net.alternativeproto.vote": {
      "tier": "action",
      "notes": "Vote record on a third-party protocol.",
      "app": "alternativeproto"
    },
    "net.anisota.feed.list": {
      "tier": "creation",
      "app": "anisota"
    },
    "net.anisota.feed.post": {
      "tier": "creation",
      "app": "anisota"
    },
    "net.anisota.player.state": {
      "tier": "filtered",
      "notes": "Anisota game player state.",
      "app": "anisota"
    },
    "network.cosmik.card": {
      "tier": "filtered",
      "notes": "Link-in-bio card; consumption signal.",
      "app": "cosmik"
    },
    "network.cosmik.collection": {
      "tier": "filtered",
      "notes": "Stale registry id \u2014 Cosmik formerly in app registry.",
      "app": "cosmik"
    },
    "network.cosmik.collectionLink": {
      "tier": "filtered",
      "app": "cosmik"
    },
    "network.cosmik.connection": {
      "tier": "filtered",
      "app": "cosmik"
    },
    "network.cosmik.follow": {
      "tier": "filtered",
      "app": "cosmik"
    },
    "one.papili.post": {
      "tier": "creation",
      "app": "papili"
    },
    "org.hypercerts.claim.activity": {
      "tier": "creation",
      "app": "hypercerts",
      "notes": "A hypercert: an authored claim of work done, with title, description, and weighted contributors."
    },
    "org.hypercerts.claim.collection": {
      "tier": "creation",
      "app": "hypercerts",
      "notes": "Older shape of the project container that groups claims. Superseded by org.hypercerts.collection."
    },
    "org.hypercerts.claim.evaluation": {
      "tier": "creation",
      "app": "hypercerts",
      "notes": "An assessment of a claim carrying a score and a written summary. An opinion with a body."
    },
    "org.hypercerts.collection": {
      "tier": "creation",
      "app": "hypercerts",
      "notes": "An authored project container grouping hypercert claims, with its own title, banner, and description."
    },
    "org.impactindexer.review.comment": {
      "tier": "creation",
      "app": "impactindexer",
      "notes": "A written review of a hypercert claim, like a Popfeed or BookHive review."
    },
    "org.v-it.skill": {
      "tier": "creation",
      "app": "vit"
    },
    "os.aether.docs.presentation": {
      "tier": "creation",
      "app": "aetherdocs"
    },
    "pics.pixl.image": {
      "tier": "creation",
      "app": "pixl"
    },
    "place.stream.broadcast.origin": {
      "tier": "filtered",
      "app": "streamplace",
      "notes": "Broadcast origin/infrastructure record."
    },
    "place.stream.chat.message": {
      "tier": "filtered",
      "app": "streamplace",
      "notes": "Ephemeral chat message."
    },
    "place.stream.chat.profile": {
      "tier": "filtered",
      "app": "streamplace",
      "notes": "Chat profile metadata."
    },
    "place.stream.key": {
      "tier": "filtered",
      "app": "streamplace",
      "notes": "Stream key \u2014 sensitive infrastructure record."
    },
    "place.stream.livestream": {
      "tier": "creation",
      "app": "streamplace"
    },
    "place.stream.metadata.configuration": {
      "tier": "filtered",
      "app": "streamplace",
      "notes": "Stream configuration metadata."
    },
    "pub.chive.eprint.submission": {
      "tier": "creation",
      "app": "chive",
      "notes": "An authored preprint: title, ordered authors with affiliations, abstract."
    },
    "pub.leaflet.authFullPermissions": {
      "tier": "filtered",
      "app": "leaflet",
      "notes": "OAuth permission record."
    },
    "pub.leaflet.comment": {
      "tier": "creation",
      "app": "leaflet"
    },
    "pub.leaflet.interactions.recommend": {
      "tier": "action",
      "app": "leaflet"
    },
    "quest.atmo.checkin": {
      "tier": "creation",
      "app": "atmorsvp",
      "notes": "Attendance, classified like community.lexicon.calendar.rsvp (creation) rather than as engagement. The creation tier description names RSVPs explicitly."
    },
    "quest.atmo.event": {
      "tier": "creation",
      "app": "atmorsvp"
    },
    "sh.tangled.actor.profile": {
      "tier": "filtered",
      "app": "tangled",
      "notes": "Profile metadata record."
    },
    "sh.tangled.feed.star": {
      "tier": "action",
      "app": "tangled"
    },
    "sh.tangled.graph.follow": {
      "tier": "action",
      "app": "tangled"
    },
    "sh.tangled.repo": {
      "tier": "creation",
      "app": "tangled"
    },
    "sh.tangled.repo.issue": {
      "tier": "creation",
      "app": "tangled"
    },
    "sh.tangled.repo.pull": {
      "tier": "creation",
      "app": "tangled"
    },
    "site.standard.document": {
      "tier": "creation",
      "app": "standard"
    },
    "so.sprk.feed.post": {
      "tier": "creation",
      "app": "spark"
    },
    "so.sprk.story.post": {
      "tier": "creation",
      "app": "spark"
    },
    "social.colibri.actor.data": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Actor metadata."
    },
    "social.colibri.approval": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Moderation approval record."
    },
    "social.colibri.category": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Category metadata."
    },
    "social.colibri.channel": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Channel definition."
    },
    "social.colibri.channel.read": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Read-state marker."
    },
    "social.colibri.community": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Community definition."
    },
    "social.colibri.membership": {
      "tier": "creation",
      "app": "colibri"
    },
    "social.colibri.message": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Chat message \u2014 high-volume conversational signal, not portfolio."
    },
    "social.colibri.reaction": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Chat reaction."
    },
    "social.colibri.richtext.facet": {
      "tier": "filtered",
      "app": "colibri",
      "notes": "Richtext facet sub-record."
    },
    "social.crate.content": {
      "tier": "creation",
      "app": "crate"
    },
    "social.crate.note": {
      "tier": "creation",
      "app": "crate"
    },
    "social.grain.gallery": {
      "tier": "creation",
      "app": "grain"
    },
    "social.grain.gallery.item": {
      "tier": "filtered",
      "app": "grain",
      "notes": "Item-within-gallery; rendered via parent gallery."
    },
    "social.grain.photo": {
      "tier": "filtered",
      "app": "grain",
      "notes": "Raw photo asset; surfaced via the gallery that references it."
    },
    "social.grain.photo.exif": {
      "tier": "filtered",
      "app": "grain",
      "notes": "EXIF metadata for a photo."
    },
    "social.grain.story": {
      "tier": "filtered",
      "app": "grain",
      "notes": "Ephemeral story format."
    },
    "social.passports.fiftyStates.visit": {
      "tier": "creation",
      "app": "passports"
    },
    "social.passports.travel.leg": {
      "tier": "creation",
      "app": "passports"
    },
    "social.pinksky.app.preference": {
      "tier": "filtered",
      "app": "bluesky",
      "notes": "Pinkleap (Bluesky client) app preferences."
    },
    "social.popfeed.actor.profile": {
      "tier": "filtered",
      "app": "popfeed",
      "notes": "Profile metadata record."
    },
    "social.popfeed.challenge.participation": {
      "tier": "filtered",
      "app": "popfeed",
      "notes": "Challenge participation tracking."
    },
    "social.popfeed.feed.like": {
      "tier": "action",
      "app": "popfeed"
    },
    "social.popfeed.feed.note": {
      "tier": "creation",
      "app": "popfeed"
    },
    "social.popfeed.feed.post": {
      "tier": "creation",
      "app": "popfeed"
    },
    "social.popfeed.feed.review": {
      "tier": "creation",
      "app": "popfeed"
    },
    "social.psky.feed.post": {
      "tier": "creation",
      "app": "picosky"
    },
    "space.roomy.space.personal": {
      "tier": "creation",
      "app": "roomy"
    },
    "st.lifepo.lifeEvent": {
      "tier": "creation",
      "app": "lifepo"
    },
    "stream.thought.blip": {
      "tier": "creation",
      "app": "streamthought"
    },
    "tech.waow.doodl.drawing": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.doodl.icon": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.doodl.iconset": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.doodl.logo": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.pollz.poll": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.slides.deck": {
      "tier": "creation",
      "app": "waow"
    },
    "tech.waow.slides.slide": {
      "tier": "creation",
      "app": "waow",
      "notes": "Individual slides are components of a deck. Both are kept; the consumer decides whether to collapse them."
    },
    "wiki.lichen.note": {
      "tier": "creation",
      "app": "lichen"
    },
    "wiki.lichen.wiki": {
      "tier": "creation",
      "app": "lichen"
    },
    "xyz.statusphere.status": {
      "tier": "filtered",
      "notes": "Statusphere emoji status \u2014 leisure signal.",
      "app": "statusphere"
    }
  }
}
